import { render, staticRenderFns } from "./ProjectWaterSubmissionForm.vue?vue&type=template&id=95286382"
import script from "./ProjectWaterSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectWaterSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports